'use strict'

import routeMap from './routeMap'

let changeHandler = null
let linkGenerator = null
let routerState = {}

export function updateState(state) {
  routerState = Object.freeze({
    path: state.url,
    name: state.name,
    params: state.params,
  })
}

export function getState() {
  return routerState
}

export function updateChangeHandler(handler) {
  if (typeof handler === 'function') {
    changeHandler = handler
  }
}

export function updateLinkGenerator(handler) {
  if (typeof handler === 'function') {
    linkGenerator = handler
  }
}

export function execChangeHandler({ name, params }) {
  try {
    const routeName = mapRouteName(name)
    const routeParams = fixParams(params)
    changeHandler(routeName, routeParams)
  } catch (ex) {
    console.error(ex)
  }
}

export function generateLink(link) {
  try {
    const { name, params } = link
    const routeName = mapRouteName(name)
    const routeParams = fixParams(params)
    return linkGenerator(routeName, routeParams)
  } catch (e) {
    return 'javascript:void(0);'
  }
}

export function mapRouteName(name) {
  if (name && typeof name !== 'string') {
    throw new Error('Angular route name must be a string')
  }
  return routeMap[name] || name || 'dashboard'
}

export function fixParams(params) {
  return params
}

export default function routerLinkServiceConstructor() {
  return function routerLinkService() {
    return {
      setHandler(handler, linkFn) {
        updateChangeHandler(handler, linkFn)
        updateLinkGenerator(linkFn)
      },
      setState(state) {
        updateState(state)
      },
      getState() {
        return getState()
      },
      changePage(params) {
        execChangeHandler(params)
      },
    }
  }
}
